import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { User, UserIndicator } from '../services/user.types';
import { UserService } from '../services/user.service';
import { UserIndicatorsService } from '../services/user-indicators.service';
import { combineLatest, filter, Subject, takeUntil, tap } from 'rxjs';
import { ISvcUserAvatar, UserAvatarSize } from '@solvace/component/svc-user-avatar';
import { MainService } from 'projects/myworkspace/src/app/board/main/main.service';
import { ContractedModules } from 'projects/myworkspace/src/app/board/main/models/contracted-modules.interface';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'user-card',
  templateUrl: './user-card.component.html',
  styleUrls: ['./user-card.component.scss'],
})
export class UserCardComponent implements OnInit {
  private readonly _mainService = inject(MainService);
  private readonly _destroyRef = inject(DestroyRef);

  user: User;
  isUserLoading = true;
  userAvatar: ISvcUserAvatar;
  indicators: UserIndicator[];
  protected showElements: ContractedModules;

  constructor(
    private _userService: UserService,
    private _userIndicatorsService: UserIndicatorsService
  ) {
    this.loadElementsView();
  }

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  ngOnInit(): void {
    this._userService.user$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((user) => {
        this.user = user;
        if (!user) {
          this.isUserLoading = true;
          return;
        }
        this.userAvatar = {
          name: user.firstLastName,
          picture: user.pictureFile,
          initialsColor: user.initialsColor,
          size: UserAvatarSize.Workspace,
        };
        this.isUserLoading = false;
      });

    //Subscribe to user indicators
    combineLatest([this._userService.user$.pipe(filter(Boolean)), this._userIndicatorsService._userIndicators$])
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(([user, indicators]) => {
        this.indicators = Object.keys(indicators)
          .filter((x) => user.viewProfileType === 0 || !(x === 'lil' || x === 'defectTag'))
          .map((key) => {
            const alwaysVisible = ['actionPlan', 'checkList'].includes(key);

            return {
              key,
              ...indicators[key],
              show: alwaysVisible ? true : (this.showElements?.[key] ?? false),
            };
          });
      });
  }

  private loadElementsView(): void {
    this._mainService.reloadMenu$
      .pipe(
        takeUntilDestroyed(this._destroyRef),
        tap((response: ContractedModules) => {
          if (response) {
            this.showElements = response;
          }
        })
      )
      .subscribe();
  }
}
